/**
 * @file index.tsx
 * @module app/modules/sales-management/sales-manager/index
 * @description Implements the index interface for sales-management operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import CustomerAssignment from './customer-assignment/customer-assignment';
import Dashboard from './dashboard/dashboard';
import Notifications from './notifications';
import Orders from './orders/orders';
import Reports from './reports/reports';
import RepDetails from './sales-representative/rep-details';
import SalesRepresentative from './sales-representative/sales-representative';
import TargetManagement from './target-management/target-management';
const SalesManagerIndex = () => {
  return (
    <>
      <Routes>
        <Route element={<Outlet />}>
          <Route
            index
            element={<Navigate to="sales-management/manager/dashboard" />}
          />
          <Route
            path="dashboard"
            element={
              <>
                <Dashboard />
              </>
            }
          />
          <Route
            path="sales-representative"
            element={
              <>
                <SalesRepresentative />
              </>
            }
          />
          <Route
            path="sales-representative/rep-details"
            element={
              <>
                <RepDetails />
              </>
            }
          />
          <Route
            path="customer-assignment"
            element={
              <>
                <CustomerAssignment />
              </>
            }
          />
          <Route
            path="target-management"
            element={
              <>
                <TargetManagement />
              </>
            }
          />
          <Route
            path="orders"
            element={
              <>
                <Orders />
              </>
            }
          />
          <Route
            path="reports"
            element={
              <>
                <Reports />
              </>
            }
          />
          <Route
            path="notifications"
            element={
              <>
                <Notifications />
              </>
            }
          />
          <Route path="*" element={<Navigate to="/error/404" />} />
        </Route>
      </Routes>
    </>
  );
};
export default SalesManagerIndex;
